import type { FileCandidate } from "@rui/FileUpload/types";

export const getFileDuration = (file: File): Promise<number | null> => {
  const element = file.type.includes("m4a") ? "audio" : "video";
  return new Promise((resolve, reject) => {
    const el = document.createElement(element);
    el.preload = "metadata";
    el.onloadedmetadata = () => {
      window.URL.revokeObjectURL(el.src);
      const duration = el.duration;
      if (isNaN(duration)) {
        resolve(null);
      } else {
        resolve(duration);
      }
    };
    el.onerror = () => {
      window.URL.revokeObjectURL(el.src);
      reject();
    };
    el.src = URL.createObjectURL(file);
  });
};

export const validateFileDurations = async (
  fileCandidates: FileCandidate[],
  availableCredits: number
) => {
  let remainingCredits = availableCredits;
  const filesWithDuration: FileCandidate[] = [];

  for (let i = 0; i < fileCandidates.length; i++) {
    const currentFileCandidate = fileCandidates[i];
    const duration = await getFileDuration(currentFileCandidate.file);
    if (duration) {
      const durationInMinutes = duration / 60;
      remainingCredits -= durationInMinutes;
      currentFileCandidate.duration = durationInMinutes;
      currentFileCandidate.isValid = remainingCredits >= 0;
    }
    filesWithDuration.push(currentFileCandidate);
  }

  return filesWithDuration;
};
